import type { ColumnsState } from '@ant-design/pro-components';
import { createAppRequest } from './request';

const request = createAppRequest();
export type TablePreference = {
  columnsState: Record<string, ColumnsState>;
  density: 'default' | 'middle' | 'small';
  version: number;
};

const url = (key: string) =>
  `/bff/zy-hr/user-table-preferences/${encodeURIComponent(key)}`;

export const getTablePreference = (key: string) =>
  request<TablePreference | null>(url(key), { method: 'GET' });

export const saveTablePreference = (key: string, data: TablePreference) =>
  request<TablePreference>(url(key), { method: 'PUT', data });
